import { Link } from "../../../components/link";

export const useLink = () => {
  return Link;
};
